<template>
    <header :id="id" :style="{ background: `url(${background})` }" :class="{'no-background' : !background}" class="header-page bg-cover bg-center mb-5">
        <b-container>
            <b-row>
                <b-col class="text-center text-white">
                    <h1 class="text-white">{{ title }}</h1>
                  <strong v-if="background"></strong>
                    <p class="lead"><slot></slot></p>
                </b-col>
            </b-row>
        </b-container>
    </header>
</template>

<script>
 export default {
    name: 'HeaderInnerPage',
     props: {
         id: { type: String, required: true }, title: String, background: null
     },
    mounted() {

    },
    data() {
    return {

        }
    },
    methods: {

    },
    computed: {

    }
 };
</script>
